import { render, staticRenderFns } from "./ItensAdesaoBtnAcoes.vue?vue&type=template&id=1ec6339a&scoped=true"
import script from "./ItensAdesaoBtnAcoes.vue?vue&type=script&lang=js"
export * from "./ItensAdesaoBtnAcoes.vue?vue&type=script&lang=js"
import style0 from "./ItensAdesaoBtnAcoes.vue?vue&type=style&index=0&id=1ec6339a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec6339a",
  null
  
)

export default component.exports